
import Verify from "../../../assets/filled/Verify.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function VerifyIcon({ className, dataTestid = "VerifyIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Verify data-testid={dataTestid} className={classes} {...rest} />
  );
}
